import styled, { keyframes } from 'styled-components';

const confettiAnimation = keyframes`
  0% { transform: translateY(0) rotate(0deg); }
  100% { transform: translateY(-100vh) rotate(360deg); }
`;

export const Wrapper = styled.div`
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Actions = styled.div`
  position: absolute;
  bottom: 50px;
  right: 50px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  button {
    box-shadow: 0px 0px 15px rgba(255, 105, 97, 0.7);
    font-weight: bold;
    animation: pulse 1.5s infinite alternate;
  }
`;

export const Price = styled.div`
  text-align: center;
  font-size: 30px;
  color: white;
  margin-bottom: 20px;
  position: absolute;
  bottom: 50px;
  left: 50px;
  font-weight: bold;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.8);
  transform: perspective(500px) rotateY(-20deg);
  padding: 10px 20px;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0));
  backdrop-filter: blur(10px);
  display: none;
  box-shadow: 0px 4px 20px rgba(255, 255, 255, 0.2), inset 0px 0px 10px rgba(255, 255, 255, 0.1);
`;

export const OfferText = styled.div`
  font-size: 40px;
  font-weight: 800;
  background: linear-gradient(45deg, red, darkred);
  color: white;
  padding: 10px 25px;
  border-radius: 12px;
  text-transform: uppercase;
  text-align: center;
  box-shadow: 0 0 20px rgba(255, 0, 0, 0.8), inset 0px 0px 15px rgba(0, 0, 0, 0.6);
  transform: perspective(500px) rotateX(5deg);
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: perspective(500px) rotateX(0deg) scale(1.1);
    box-shadow: 0 0 30px rgba(255, 0, 0, 1), inset 0px 0px 15px rgba(0, 0, 0, 0.8);
  }

  span {
    text-transform: lowercase;
    font-size: 20px;
  }
`;

export const Previous = styled.div`
  text-decoration: line-through;
  color: red;
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 24px;
  opacity: 0.7;
  text-shadow: 0px 0px 10px rgba(255, 0, 0, 0.7);
  transition: opacity 0.3s ease-in-out;

  &:hover {
    opacity: 1;
    transform: scale(1.05);
  }
`;

export const Bottom = styled.div`
  position: absolute;
  animation: bounce 1s infinite;
  animation-delay: 5s;
  animation-iteration-count: infinite;
  bottom: 20px;
  width: 600px;
  left: calc(50% - 300px);
  color: white;
  font-size: 24px;
  font-weight: bold;
  text-shadow: 0px 0px 5px rgba(255, 255, 255, 0.5);
  opacity: 0.7;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Details = styled.div`
  position: absolute;
  top: 20px;
  left: 50%;
  max-width: 500px;
  text-align: center;
  transform: translateX(-50%);
  font-size: 18px;
  color: white;
  font-weight: bold;
  text-shadow: 0px 0px 5px rgba(255, 255, 255, 0.5);
  opacity: 0.7;

  span {
    text-transform: lowercase;
    font-size: 12px;
  }
`;

export const Offer = styled.div`
  font-size: 15px;
  font-weight: bold;
  text-align: center;
`;

export const Header = styled.div`
  position: absolute;
  top: 130px;
  width: 1000px;
  margin-right: 100px;
  display: none;
`;

export const H1 = styled.div`
  font-size: 70px;
  font-weight: bold;
  color: #ff9345;
  line-height: 50px;
  text-shadow: 0 0 10px rgba(255, 147, 69, 0.8);
`;

export const Line = styled.div`
  font-size: 40px;
  font-weight: bold;
  color: #fac6a2;
`;

export const Catch = styled.div`
  font-size: 24px;
  font-weight: bold;
  color: #45bcff;
  position: absolute;
  right: 0;
  top: 60px;
`;
